import './index.scss'

import React, { useRef, useEffect } from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import Accordion from 'components/Accordion'
import Icon from 'components/Icon'

const bem = new BEMHelper('message')

export default function Message({
  children,
  type,
  focus,
  details,
  unbox,
  icon,
  spaceless,
  spacingTop,
  suffix,
  onClose,
}) {
  const wrapperRef = useRef()

  useEffect(() => {
    if (focus && wrapperRef.current) {
      wrapperRef.current.focus()
    }
  }, [focus])

  return (
    <div
      {...bem('', {
        [type]: type,
        unbox,
        details,
        spaceless,
        'spacing-top': spacingTop,
      })}
      ref={wrapperRef}
      tabIndex="0"
    >
      <span {...bem('message')}>
        {type && <Icon icon={icon || type} {...bem('icon')} />}
        <span {...bem('content')}>{children}</span>
        {suffix && <span {...bem('suffix')}>{suffix}</span>}
        {Boolean(onClose) && (
          <button type="button" onClick={onClose} aria-label="Lukk" {...bem('close')}>
            <Icon icon="x" />
          </button>
        )}
      </span>
      {details && (
        <div {...bem('details')}>
          <Accordion title="Vis mer" subtle spaceless full>
            {details}
          </Accordion>
        </div>
      )}
    </div>
  )
}

Message.propTypes = {
  children: T.any,
  type: T.oneOf(['info', 'warning', 'success', 'notice']),
  focus: T.bool,
  details: T.any,
  suffix: T.any,
  unbox: T.bool,
  icon: T.string,
  spaceless: T.bool,
  spacingTop: T.bool,
  onClose: T.func,
}
